export default __webpack_public_path__ + "static/media/AMS - Download to OI_Dark2.319c8180.svg";